import uniqueId from 'lodash/uniqueId';
import './styles.css';
import PropTypes from 'prop-types';
import React, {forwardRef, useEffect, useImperativeHandle} from 'react';
import BasicTooltip from '../../../../components/BasicTooltip';
import LoadMask from '../../../../components/LoadMask';
import PagePagination from '../../../../components/PagePagination';
import ENDPOINT from '../../../../constants/endpoints';
import {useGrid} from '../../../../hooks/useGrid';

const UpdatedProfile = forwardRef((props, ref) => {
  const { id } = props;

  const grid = useGrid(
    ENDPOINT.COLLECTION.CANDIDATE_PROFILE_UPDATED_LOG,
    null,
    false
  );

  useEffect(() => {
    grid.actions.fetch({ id });
  }, [id]);

  useImperativeHandle(ref, () => ({
    reload: () => {
      grid.actions.fetch();
    },
  }));

  return Number(grid.data.rowsCount) > 0 ? (
    <div className="sidebar__widget updated-profile-widget">
      {grid.data.isFetching && <LoadMask relative />}

      <div className="sidebar__block">
        <h3 className="sidebar__title">Updated Profile</h3>
      </div>

      <div className="sidebar__block">
        <div className="sidebar__table">
          {grid.data.rows.map(record => (
            <div className="sidebar__table-row" key={uniqueId()}>
              <BasicTooltip tooltip={record.Tooltip}>
                <div
                  className="sidebar__table-column"
                  style={{
                    flex: '1 1 175px',
                  }}
                >
                  <div className="sidebar__text">
                    <span className="sidebar__text">{record.FullName}</span>,{' '}
                    <span className="sidebar__text">{record.Action}</span>
                  </div>
                </div>
                <div
                  className="sidebar__table-column"
                  style={{
                    flex: '1 0 72px',
                    marginRight: 0,
                  }}
                >
                  <div className="sidebar__text">{record.Date}</div>
                </div>
              </BasicTooltip>
            </div>
          ))}
        </div>
        {Number(grid.data.rowsCount) > Number(grid.data.perPage) && (
          <div className="sidebar__pagination">
            <PagePagination
              page={grid.data.page}
              perPage={grid.data.perPage}
              count={grid.data.rowsCount}
              pageRangeDisplayed={3}
              controlFunc={grid.actions.readPage}
              hideFirstLastPages={false}
              hideNavigation={true}
              minimalStyle={true}
              scrollToTop={false}
            />
          </div>
        )}
      </div>
    </div>
  ) : null;
});

UpdatedProfile.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default UpdatedProfile;
